import React, { useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
  CFormInput,
} from '@coreui/react-pro'
import ToastComponent from 'src/components/common/TaostComponent'
import EmailQuotaService from 'src/service/EmailQuotaService'

const TopTenManagerEmail = () => {
  const [visible, setVisible] = useState(false)
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const sendEmails = () => {
    EmailQuotaService.topManagerOverall().then((res) => {
      ToastComponent(res.message, res.success ? 'success' : 'error')
    })
  }

  const testEmail = () => {
    setVisible(true)
  }

  const handleTestSubmit = () => {
    if (!email) {
      ToastComponent('Please enter an email address', 'error')
      return
    }
    const data = { email }
    setLoading(true)
    EmailQuotaService.testTopManagerOverall(data).then((res) => {
      setLoading(false)
      ToastComponent(res.message, res.success ? 'success' : 'error')
      if (res.success) {
        setVisible(false)
        setEmail('')
      }
    })
  }

  return (
    <>
      <table className="main-table table innertable">
        <thead>
          <tr>
            <th width="30%">Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Top 10 Managers (Overall)</td>
            <td>
              <CButton onClick={sendEmails}>Send Now</CButton> &nbsp;
              <CButton color="info" onClick={testEmail}>
                Test Email
              </CButton>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Test Email Modal */}
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Send Test Email</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CFormInput
            type="email"
            label="Email Address"
            placeholder="Enter email to send test"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleTestSubmit} disabled={loading}>
            {loading ? 'Sending...' : 'Send Test Email'}
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default TopTenManagerEmail
